import find from 'lodash/find';
import { resolveErrorMessage } from '../errors/services';
import { Mapper } from '../core';
import { fetchOffer, fetchOffers, postOffer, offerAction } from './api';
import {
  createAsyncThunk,
  createSlice,
  createSelector,
} from '@reduxjs/toolkit';

export const loadOffers = createAsyncThunk(
  'offers/load',
  async ({ filter, accountType }) => await fetchOffers(filter, accountType),
);
export const loadOffer = createAsyncThunk(
  'offer/load',
  async ({ offerId, accountType }) => await fetchOffer(offerId, accountType),
);
export const setOfferStatus = createAsyncThunk(
  'offers/updateOffer',
  async ({ offerId, action, values, accountType }) =>
    await offerAction(offerId, action, values, accountType),
);
export const createOffer = createAsyncThunk(
  'offers/create',
  async ({ talentId, roleId, producerId, values }) =>
    await postOffer(talentId, roleId, producerId, values),
);

const offersSlice = createSlice({
  name: 'offers',
  initialState: {
    offers: [],
    loading: false,
    error: null,
    sort: '-createdAt',
    filterData: null,
  },
  reducers: {
    setOffersSort(state, action) {
      state.sort = action.payload;
    },
    setOffersFilterData(state, action) {
      state.filterData = action.payload;
    },
    clearOffersFilterData(state) {
      state.filterData = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadOffers.pending, (state, _) => {
        state.loading = true;
      })
      .addCase(loadOffers.fulfilled, (state, action) => {
        state.offers = action.payload.data;
        state.loading = false;
      })
      .addCase(loadOffers.rejected, (state, action) => {
        state.error = resolveErrorMessage(action.error);
      })
      .addCase(setOfferStatus.fulfilled, (state, action) => {
        // TODO: verify whether this is still the case
        // Mapper.addOrReplace() is causing unnecessary rerenders here
        state.offers = state.offers.map((offer) => {
          return offer.id !== action.payload.data.id
            ? offer
            : action.payload.data;
        });
      })
      .addCase(setOfferStatus.rejected, (state, action) => {
        state.error = resolveErrorMessage(action.error);
      })
      .addCase(loadOffer.pending, (state, _) => {
        state.loading = true;
      })
      .addCase(loadOffer.fulfilled, (state, action) => {
        state.offers = Mapper.addOrReplace(state.offers, action.payload.data);
        state.loading = false;
      })
      .addCase(createOffer.pending, (state, _) => {
        state.loading = true;
      })
      .addCase(createOffer.fulfilled, (state, action) => {
        state.offers = [...state.offers, action.payload.data];
        state.loading = false;
      })
      .addCase(createOffer.rejected, (state, action) => {
        state.error = resolveErrorMessage(action.error);
      });
  },
  selectors: {
    getOffers: (state) => state.offers,
    getOffersSort: (state) => state.sort,
    getOffersFilterData: (state) => state.filterData,
    getOffersLoading: (state) => state.loading,
  },
});

export const { setOffersSort, setOffersFilterData, clearOffersFilterData } =
  offersSlice.actions;
export const reducer = offersSlice.reducer;
export const {
  getOffers,
  getOffersSort,
  getOffersFilterData,
  getOffersLoading,
} = offersSlice.selectors;

export const getOfferById = (id) =>
  createSelector(getOffers, (offers) =>
    find(offers, (offer) => offer.id === id),
  );
